import { render } from "./ReportLakeDescription.vue?vue&type=template&id=94e9e964"
import script from "./ReportLakeDescription.vue?vue&type=script&lang=js"
export * from "./ReportLakeDescription.vue?vue&type=script&lang=js"

import "./ReportLakeDescription.vue?vue&type=style&index=0&id=94e9e964&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__